import React, { Fragment, useEffect, useState } from "react";
import { CustomGetAPI, CustomPostAPI } from "./Utils/APIConnector";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Loader from "./Utils/Loader";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import Popup from "./LiveScoreCardpopups/Popup";
import { VenueDate } from "./Utils/common";
import { to } from "react-spring";

export default function BulkVenueRequest() {
  const [availableVenueData, setAvailableVenueData] = useState();
  const [selectedVenueData, setSelectedVenueData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [venuePrice, setVenuePrice] = useState(0);
  const [venueremainingPrice, setVenueRemainingPrice] = useState(0);
  const [advancePrice, setAdvancePrice] = useState(0);
  const navigate = useNavigate();
  const loction = useLocation();
  const param = useParams();
  const UserID = parseInt(window.localStorage.getItem("userid"));
  const username = window.localStorage.getItem("UserName");
  const phoneno = window.localStorage.getItem("phoneno");
  const UserEmail = window.localStorage.getItem("UserEmail");
  const cookies = new Cookies();
  const Isapp = cookies.get("Isapp");
  useEffect(() => {
    getBulkVenueRequest();
  }, []);

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  });
  const getBulkVenueRequest = async () => {
    setIsLoading(true);
    try {
      await CustomGetAPI(`/venue/SearchNearByVenues/${param.bookingId}`).then(
        (result) => {
          if (result) {
            result = JSON.parse(result);
            if (result.status == "Success") {
              setAvailableVenueData(result?.venues);

              if (
                new Date(result?.venues[0]?.createdAt) < new Date() ||
                result?.venues?.filter((item) => item?.hasBookingDone)?.length >
                  0
              ) {
                Swal.fire({
                  icon: "warning",
                  title: "Link Expired!",
                  showConfirmButton: true,
                  confirmButtonText: "Ok",
                }).then((result) => {
                  window.history.go(-1);
                });
              }
              setIsLoading(false);
            }
          }
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBooking = (data) => {
    if (
      new Date(data?.createdAt) < new Date() ||
      availableVenueData?.filter((item) => item?.hasBookingDone)?.length > 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Link Expired!",
        showConfirmButton: true,
        confirmButtonText: "Ok",
      }).then((result) => {
        window.history.go(-1);
      });
    } else {
      if (data?.isAccept == 1) {
        const amount = data?.newTimeSlots?.reduce(
          (acc, Total) => acc + Total?.price * (Total?.bookingAmount / 100),
          0
        );
        const TotalAmount = data?.newTimeSlots?.reduce(
          (acc, Total) => acc + Total?.price,
          0
        );
        const remainingAmount = TotalAmount - amount;
        const advanceAmount = (amount * 100) / TotalAmount;
        setVenuePrice(amount);
        setVenueRemainingPrice(remainingAmount);
        setAdvancePrice(advanceAmount);
        setSelectedVenueData(data);
        setShow(true);
      } else {
        const redirectUrl = `/venue-search/${data?.venueAddress?.cityName?.toLocaleLowerCase()}/${data?.venueName
          ?.replace(/\s+/g, "-")
          ?.toLocaleLowerCase()}`;
        window.localStorage.setItem(
          "venueRedirectURL",
          window.location.pathname
        );
        navigate(redirectUrl);
      }
    }
  };

  const payNow = async () => {
    var options;

    const data = JSON.stringify({
      Isfromvenuepayment: true,
      venueBookings: selectedVenueData?.newTimeSlots?.map((slot) => ({
        date: slot.startTime.split("T")[0],
        startTime: slot.startTime.split("T")[1].substring(0, 5),
        endTime: slot.endTime.split("T")[1].substring(0, 5),
        SlotDuration: selectedVenueData?.newTimeSlots?.length / 2,
      })),
      VenueId: selectedVenueData?.venueId,
      SurfaceId: selectedVenueData?.venueSportId,
      Date: selectedVenueData?.date,
      Amount: venuePrice,
      UserId: UserID,
      SportId: selectedVenueData?.sportId,
      TotalAmount: venueremainingPrice + venuePrice,
      ExistingBookingId: param?.bookingId,
    });

    await CustomPostAPI(`/payment/initialize`, data).then((result) => {
      if (result === undefined || result === "") {
        alert("Something went wrong");
      } else {
        result = JSON.parse(result);
        if (result.status === "Success") {
          const order_id = result.orderResponse.orderId;
          const venuepaymentlogid = result.venuepaymentlogid;
          options = {
            // key: Isapp ? "" : result.orderResponse.razorPayAPIKey,
            amount: result.orderResponse.amount,
            name: "Venue Booking Fee",
            description: "Total_venue_booking_fee",
            image: "https://dev.cricbuddy.in/images/cricketFlash.svg",
            order_id: order_id,
            handler: async (data) => {
              try {
                data["Isfromvenuepayment"] = true;
                data["venuepaymentlogid"] = venuepaymentlogid;
                data["venueBookings"] = availableVenueData?.newTimeSlots?.map(
                  (slot) => ({
                    date: slot.startTime.split("T")[0],
                    startTime: slot.startTime.split("T")[1].substring(0, 5),
                    endTime: slot.endTime.split("T")[1].substring(0, 5),
                  })
                );
                data["SurfaceId"] = selectedVenueData?.venueSportId;
                data["SportId"] = selectedVenueData?.sportId;
                data["VenueId"] = selectedVenueData?.venueId;
                data["Date"] = selectedVenueData?.date;
                data["BookBy"] = UserID;
                data["convertedId"] = "";

                var paymentData = JSON.stringify(data);
                const result = await CustomPostAPI(
                  "/payment/confirm",
                  paymentData
                );

                if (result === undefined || result === "") {
                  alert("Something went wrong with the payment.");
                } else {
                  const parsedResult = JSON.parse(result);
                  if (parsedResult?.status === "Error") {
                    Swal.fire({
                      icon: "warning",
                      text: "Selected time slot for Surface and sport is already booked your amount will be refunded in 5-6 business days.",
                      showConfirmButton: true,
                      allowOutsideClick: true,
                      confirmButtonText: "View Bookings",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.localStorage.setItem(
                          "RedirectURL",
                          window.location.href
                        );
                        navigate("/venue-booking-details");
                      }
                    });
                  } else {
                    Swal.fire({
                      icon: "success",
                      text: "Your venue booking is confirmed successfully, you will receive notification on your WhatsApp as well as you can check your booking in your account.",
                      showConfirmButton: true,
                      allowOutsideClick: true,
                      confirmButtonText: "View Bookings",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.localStorage.setItem(
                          "RedirectURL",
                          window.location.href
                        );
                        navigate("/venue-booking-details");
                      } else {
                        window.location.reload();
                      }
                    });
                  }
                }

                document.body.style.overflow = "auto";
              } catch (error) {
                // Handle payment failure
                console.error("Payment failed:", error);
                CustomGetAPI(
                  `/payment/AddPaymenterror/${error ?? ""}/${UserID}`
                );
              }
            },
            prefill: {
              name: username,
              email: UserEmail ? UserEmail : "",
              contact: phoneno,
            },
            theme: {
              color: "#F3F3F3",
            },
            config: {
              display: {
                hide: [
                  { method: "paylater" },
                  { method: "netbanking" },
                  { method: "wallet" },
                ],
              },
            },
            webview_intent: true,

            // redirect: true,
            // callback_url: callback_url,
            timeout: 300,
            modal: {
              ondismiss: function () {
                document.body.style.overflow = "auto";
              },
            },
          };
          if (!Isapp) {
            options.key = result.orderResponse.razorPayAPIKey;
          }
          if (Isapp) {
            options.amount = options.amount * 100;
            // options.redirect = true;
            // options.callback_url = callback_url;
            const encodedPaymentData = encodeURIComponent(
              JSON.stringify(options)
            );
            window.location.href = `/mobile-booking?paymentData=${encodedPaymentData}`;
          } else {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.async = true;
            document.body.appendChild(script);
            const paymentObject = new window.Razorpay(options);
            paymentObject.on("payment.failed", function (response) {
              console.log("error", response);
            });
            paymentObject.open();
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Venue Not Available!",
            text: result.message,
            showConfirmButton: true,
            confirmButtonText: "Ok",
          }).then((result) => {
            window.history.go(-1);
          });
        }
      }
    });
  };
  return (
    <Fragment>
      {isLoading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <>
          <div className="row mx-0">
            <div className="col-1 ps-0">
              <img
                className="img-fluid cursor-pointer"
                src="/images/backArrow.svg"
                height={15}
                onClick={() => {
                  window.history.back();
                }}
              />
            </div>
            <div className="col-11">
              <b>Venues available based on your preferences</b>
            </div>
            <div className="col-12 text-center mt-2">
              <span>( To refresh venue availability, </span>
              <a onClick={getBulkVenueRequest} className="refreshBtn">
                click Here
              </a>
              )
            </div>
          </div>

          {availableVenueData?.length > 0 ? (
            availableVenueData?.map((availableVenue) => (
              <div
                className="row mx-0 my-3 py-2 align-items-center"
                style={{ border: "1px solid #E7666A", borderRadius: "10px" }}
              >
                <div className="col-3">
                  <img
                    className="nearbyimg"
                    src={availableVenue?.venueImages[0]?.image}
                    alt=""
                  />
                </div>
                <div className="col-9">
                  <div className="truncate-text">
                    <b>{availableVenue?.venueName}</b>
                  </div>
                  <div
                    style={{ fontSize: "12px" }}
                    className="d-flex justify-content-between flex-column"
                  >
                    <div style={{ opacity: "0.5", fontSize: "12px" }}>
                      {availableVenue?.venueAddress?.addressline2},{" "}
                      {availableVenue?.venueAddress?.cityName}
                    </div>
                  </div>
                  <div
                    style={{ fontSize: "12px" }}
                    className="d-flex justify-content-between pt-0"
                  >
                    <div style={{ fontSize: "12px", fontWeight: "500" }}>
                      Total Price:
                    </div>
                    <div
                      style={{
                        color:
                          availableVenue?.isAccept == 1 ? "#4bae4f" : "#a51e22",
                      }}
                    >
                      {availableVenue?.isAccept == 1
                        ? "Confirmed Availability"
                        : availableVenue?.isAccept == 2
                        ? "Might be Available"
                        : "Not Available"}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-0">
                    <div
                      style={{
                        background: "#EFEFEF",
                        border: "0.5px solid #0000004D",
                        borderRadius: "10px",
                        padding: "5px",
                        fontWeight: "500",
                      }}
                    >
                      {" "}
                      ₹{" "}
                      {availableVenue?.newTimeSlots?.reduce(
                        (acc, slot) => acc + slot.price,
                        0
                      )}{" "}
                    </div>
                    {availableVenue?.isAccept != 3 && (
                      <button
                        className="packageDetailsBtn"
                        onClick={() => {
                          handleBooking(availableVenue);
                        }}
                      >
                        Book Now
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center fw-semibold mt-3">
              No Venues Found
            </div>
          )}
        </>
      )}
      <Popup show={show} onHide={() => setShow(false)} venueflag={1}>
        <>
          <div className="row text-center mb-4">
            <h1 className="text-center">Payment</h1>
            <div className="col-12 text-center" style={{ fontSize: "20px" }}>
              You are booking
            </div>
            <div className="col-12 text-center">
              <b style={{ fontSize: "26px" }}>{selectedVenueData?.venueName}</b>
            </div>
            <div className="col-12 text-center">
              {selectedVenueData?.venueAddress?.addressline1},
              {selectedVenueData?.venueAddress?.addressline2},
              {selectedVenueData?.venueAddress?.cityName},
              {selectedVenueData?.venueAddress?.stateName},
              {selectedVenueData?.venueAddress?.zipcode}
            </div>
            {/* <div className="col-12 text-center">For playing</div> */}
            <div className="col-12 text-center">
              {/* <b>{SurfaceSportID.sport?.val}</b> */}
              on {VenueDate(selectedVenueData?.date).formattedDate}
            </div>
            <div className="col-12 text-center">
              at {selectedVenueData?.newTimeSlots[0].startTimeString} -{" "}
              {
                selectedVenueData?.newTimeSlots[
                  selectedVenueData?.newTimeSlots?.length - 1
                ].endTimeString
              }
              <div className="col-12 text-center">
                Pay ₹{venuePrice} ({advancePrice.toFixed(2)}
                %) now to secure your slot and
              </div>
              <div className="col-12 text-center">
                pay<b> ₹{venueremainingPrice} </b>at venue.
              </div>
            </div>
            <small className="d-none bookederror text-center text-danger w-100"></small>
            <div className="mt-3">
              <button
                onClick={() => {
                  if (!isLoading) {
                    setIsLoading(true);
                    payNow("");
                  }
                }}
                className="venueListingTop booking w-75"
              >
                Pay Now (₹{venuePrice})
              </button>{" "}
              {isLoading && (
                <img className="img-fluid ms-2" src="/images/loder.svg" />
              )}
            </div>
          </div>
        </>
      </Popup>
    </Fragment>
  );
}
